<template>
  <div id="switcher">
    <label for="switcher-checkbox">
      <input type="checkbox" class="checkbox" v-model="checkboxChecked" id="switcher-checkbox" />
      <span>pokaż też tragedie</span>
      <i class="icon-switcher icon-md"/>
    </label>
  </div>
</template>
<script type="ts">
import Vue from "vue";
import Component from "vue-class-component";
import {Model, Prop, Watch} from "vue-property-decorator";

@Component
export default class Switcher extends Vue {
  checkboxChecked = false

  @Watch("checkboxChecked")
  handleChange(value) {
    this.$emit('input', value)
  }
}
</script>
